export const STATUS_DRAFT = 1;
export const STATUS_APPROVED = 2;
export const STATUS_PENDING = 3;
export const STATUS_REJECT = 4;
export const STATUS_MODERASI = 5;

export default {
  STATUS_DRAFT,
  STATUS_APPROVED,
  STATUS_PENDING,
  STATUS_REJECT,
  STATUS_MODERASI
};
